import React, { useState } from "react";
import PrimaryModal from "../UI/Modal/PrimaryModal";
import Loader from "../UI/Loader/Loader";
import { Form, Formik } from "formik";
import { FormikInput, PrimaryButton, SecondaryButton } from "../UI";
import { importTemplateFromFigmaSchema } from "../../schemas";
import { useUserContext } from "../../contexts/UserContext";
import { importTemplateFromFigma } from "../../utils/APIs";
import Tooltip from "../UI/Tooltip";
import { permission } from "../../config/permission";
import { useContentfulContext } from "../../contexts/ContentfulContext";
import { toast } from "react-toastify";

const ImportFromFigmaModal = ({
    showModal,
    handleCloseModal,
    handleImportSuccess
}) => {
    const { userData, checkPermission } = useUserContext();
    const { content } = useContentfulContext();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const existingConfiguredRule = userData?.atAudienceConfigRule[0] || {};

    const canUserModify = existingConfiguredRule?._id
        ? checkPermission(permission.EDIT_ADOBE_TARGET_AUDIENCES_CONFIG_RULE)
        : checkPermission(permission.CREATE_ADOBE_TARGET_AUDIENCES_CONFIG_RULE)

    const handleSubmit = async (values) => {
        try {
            setLoading(true);

            const data = {
                figma_url: values.figma_url,
                figma_access_token: values.figma_access_token,
            };

            const result = await importTemplateFromFigma(
                userData?.token,
                userData?.selectedOrganization?.org_token,
                data
            )

            setError("");
            toast.success(result?.message || content?.COMMON_MESSAGE.success_msg);
            handleImportSuccess(result?.data);
        } catch (error) {
            setError(error?.message || content?.COMMON_MESSAGE.something_wrong_msg);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        handleCloseModal();
    };

    return (
        <>
            {showModal && (
                <PrimaryModal
                    title={"Import From Figma"}
                    hideModal={handleClose}
                    widthClass="max-w-3xl"
                >
                    {loading && <Loader />}

                    <div className="p-7 pt-1 space-y-6">
                        <Formik
                            initialValues={{
                                figma_url: "",
                                figma_access_token: "",
                            }}
                            validationSchema={importTemplateFromFigmaSchema}
                            onSubmit={handleSubmit}
                        >
                            {({ isSubmitting }) => (
                                <Form className="space-y-4">
                                    <p className="text-sm text-stride-heading font-medium">{"Import Component From Figma"}</p>
                                    
                                    <FormikInput
                                        id="figma_url"
                                        name="figma_url"
                                        label="Figma URL"
                                        placeholder="https://www.figma.com/file/..."
                                        helperText="Please enter the Figma File URL."
                                        disabled={!canUserModify}
                                        mandatory
                                    />

                                    <FormikInput
                                        id="figma_access_token"
                                        name="figma_access_token"
                                        label="Figma Access Token"
                                        placeholder="figd_..."
                                        helperText="Please enter your Figma Access Token. You can generate one from your Figma account settings."
                                        disabled={!canUserModify}
                                        mandatory
                                    />

                                    {error && <p className="mt-2 text-sm text-red-500">{error}</p>}
                                    <div className="flex justify-end gap-2 pt-2">
                                        <SecondaryButton type="button" handleClick={handleClose}>
                                            {"Cancel"}
                                        </SecondaryButton>
                                        {canUserModify && (
                                            <PrimaryButton type="submit" disabled={isSubmitting}>
                                                {"Submit"}
                                            </PrimaryButton>
                                        )}
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </PrimaryModal>
            )}
        </>
    );
};

export default ImportFromFigmaModal;
